import { useRouter } from '@noah-labs/fe-shared-ui-shared';
import { Helmet } from 'react-helmet';
import { PrimaryButton } from '../buttons/PrimaryButton';
import { NoahHologram } from '../images/NoahHologram';
import { AppContainer } from '../layout/AppContainer';
import { AppFooter } from '../layout/AppFooter';
import { AppHeader } from '../layout/AppHeader';
import { AppMain } from '../layout/AppMain';
import { SceneImage } from '../scene/SceneImage';
import { SceneMain } from '../scene/SceneMain';
import { SceneParagraph, SceneSubTitle, SceneTitleLarge } from '../scene/Typography';

export type PpDisabledPage = {
  ActionButton?: React.ReactElement;
  AppHeaderSlot?: React.ReactElement;
  description: string | React.ReactElement;
  title: string;
};

const DefaultAppHeader = <AppHeader backButton />;

// A generic disabled feature page
export function DisabledPage({
  ActionButton,
  AppHeaderSlot = DefaultAppHeader,
  description,
  title,
}: PpDisabledPage): React.ReactElement {
  const { goBack } = useRouter();

  return (
    <AppContainer>
      <Helmet>
        <title>Feature disabled</title>
      </Helmet>
      <AppMain sx={{ textAlign: 'center' }}>
        {AppHeaderSlot}
        <SceneMain dataQa="disabled">
          <SceneImage alt="" src={NoahHologram} />
          <SceneTitleLarge>Sorry!</SceneTitleLarge>
          <SceneSubTitle>{title}</SceneSubTitle>
          <SceneParagraph>{description}</SceneParagraph>
        </SceneMain>
      </AppMain>
      <AppFooter>
        {ActionButton || (
          <PrimaryButton color="primaryBrand" data-qa="go-back" onClick={(): void => goBack()}>
            Back
          </PrimaryButton>
        )}
      </AppFooter>
    </AppContainer>
  );
}
